import {
    TableRow,
    TableCell,
    Collapse,
    Box
} from '@mui/material';

import DetailTable from './DetailTable';
import Comment from './Comment';
import InvoiceTableFooter from './InvoiceTableFooter';

const InvoiceDetails = (props) => {
    const {
        open,
        invoice=[],
        comment
    } = props;

    return (
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse in={open} timeout="auto">
                    <Box sx={{
                            marginTop: 2,
                            marginBottom: 2,
                            width: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <DetailTable data={invoice} />
                        <InvoiceTableFooter invoices={invoice}/>
                    </Box>
                    <Comment comment={comment}/>
                </Collapse>
            </TableCell>
        </TableRow>
    )
}

export default InvoiceDetails;